export class GiftCard {
    cardnumber: string;
    pin: string;
}
